import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./asesores.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalAsesores from './asesoresModal';



export default function Asesores(props) {
    const { windowSize,setMenuActual } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);

    const [coordinadores, setCoordinadores] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const { estados, municipios, codigos } = useAuth();

    const columns = [
        {
            name: '',
            cell: (row) => {
                return (
                    <div style={{ display: "flex",position:'sticky',left:0,background:"white",zIndex:"1" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.completeName, row.id)}><MdDelete /></button>
                    </div>
                )
            },
            width: "100px",

        },
        {
            name: 'ID',
            selector: row => row.id,
            width: "70px",
        },
        {
            name: 'Nombre',
            selector: row => row.completeName,
            flex: "1",
            minWidth: "200px"
        },
        {
            name: 'Alias',
            selector: row => row.alias,
            flex: "1",
            minWidth: "100px"
        },
        {
            name: 'Oficina central',
            selector: row => row.centralOfficeName,
            flex: "1",
            minWidth: "150px"
        },
        {
            name: 'Estado',
            selector: row => row.stateName,
            flex: "1",
            minWidth: "100px"
        },
        {
            name: 'Municipio',
            selector: row => row.municipalityName,
            flex: "1",
            minWidth: "100px"
        },
        {
            name: 'Codigo Postal',
            selector: row => row.postalCodeName,
            flex: "1",
            minWidth: "230px"
        },
        {
            name: 'Coordinador',
            selector: row => row.coordinatorName,
            flex: "1",
            minWidth: "200px"
        },
        {
            name: 'Dirección',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.4'
                }}>
                    {row.address}
                </div>
            ),
            wrap: true,
            minWidth: '150px'
        },
        {
            name: 'Número',
            selector: row => row.phoneNumber,
            width: "110px",
        },
        {
            name: 'Fecha de Nacimiento',
            selector: row => row.dateOfBirth?row.dateOfBirth.split("T")[0]:"-",
            width: "190px",
        },
        {
            name: 'Fecha de Ingreso',
            selector: row => row.admissionDate?row.admissionDate.split("T")[0]:"-",
            width: "174px",
        },

    ];

    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "Esta segur@ que desea eliminar el asesor " + userName + "?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                let payload = {
                    userName: userName
                }
                api(SERVICE.deleteUser + `?AdvisorsId=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }

    const handleGetOffice = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId
                        });

                    }
                }
                setOfices(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetCoordinadores = () => {
        api(SERVICE.getCordinadoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId,
                            postalCodeId: element.postalCodeId,
                            centralOfficeId: element.centralOfficeId
                        });

                    }
                }
                setCoordinadores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdate = () => {
        api(SERVICE.getAsesores + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        if(data && data.data && data.data.paginationInfo){
                            setTotalRows(data.data.paginationInfo.totalRecords);
                        }
                        let centralOfficeName = "";
                        let stateName = "";
                        let municipalityName = "";
                        let postalCodeName = "";
                        let coordinatorName = "";
                        let search1 = ofices.findIndex(item => item.value === element.centralOfficeId);
                        if (search1 != -1) {
                            centralOfficeName = ofices[search1].label;
                        }
                        let search2 = estados.findIndex(item => item.value === element.stateId);
                        if (search2 != -1) {
                            stateName = estados[search2].label;
                        }
                        let search3 = municipios.findIndex(item => item.value === element.municipalityId);
                        if (search3 != -1) {
                            municipalityName = municipios[search3].label;
                        }
                        let search4 = codigos.findIndex(item => item.value === element.postalCodeId);
                        if (search4 != -1) {
                            postalCodeName = codigos[search4].label;
                        }
                        let search5 = coordinadores.findIndex(item => item.value === element.coordinatorId);
                        if (search5 != -1) {
                            coordinatorName = codigos[search4].label;
                        }
                        arrayTemp.push({
                            postalCodeName: postalCodeName,
                            municipalityName: municipalityName,
                            stateName: stateName,
                            centralOfficeName: centralOfficeName,
                            coordinatorName: coordinatorName,
                            ...element
                        })

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        if (codigos.length > 0 && municipios.length > 0 && ofices.length > 0 && estados.length > 0 && coordinadores.length > 0) {
            handleUpdate();
        }
    }, [ofices, coordinadores, page, perPage])
    useEffect(() => {
        handleGetOffice();
        handleGetCoordinadores();
    }, [])
    return (
        <>
            <WindowLayout
                title="ASESORES"
                route={["Inicio","Catálogos","Asesores"]}
                actions={[()=>setMenuActual("homeMenu"),()=>setMenuActual("catalogMenu")]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>

                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 70, 100]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>
            <ModalAsesores
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                handleUpdate={handleUpdate}
                municipios={municipios}
                estados={estados}
                codigos={codigos}
                ofices={ofices}
                coordinadores={coordinadores}
            />
        </>
    );
} 